import { type ContentComponent, type ExclusiveDealsContent } from '../../../../../types/construct.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';
import { HomeExclusiveDealsCardOption } from '../../../../home-components/home-exclusive-deals-card-option/home-exclusive-deals-card-option.component';

export const ExclusiveDealsHandler: ContentComponent<ExclusiveDealsContent> = ({
	content: {
		fields: {
			carousel: { items }
		}
	}
}) => {
	return <HomeCarousel widerCards={true} CardComponent={HomeExclusiveDealsCardOption} items={items} />;
};
